import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const CollectionLanding = () => (
  <Box sx={{ backgroundColor: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <Typography variant="h1" color="white">banco-de-chile - /app/sales/collection-landing/landing-info</Typography>
  </Box>
);

export default CollectionLanding;
